import { useState, type ReactNode } from 'react';
import { Check } from 'lucide-react';

interface CopyButtonProps {
  value: string | number;
  label?: string;
  children?: ReactNode;
}

export function CopyButton({ value, label = 'Copy', children }: CopyButtonProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(String(value));
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // Fallback
      const textarea = document.createElement('textarea');
      textarea.value = String(value);
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    }
  };

  return (
    <button
      className="btn btn-sm"
      onClick={handleCopy}
      aria-label={copied ? 'Copied!' : `${label}: ${value}`}
      style={{ minWidth: 'var(--touch-target-sm)' }}
    >
      {children ?? (copied ? <Check size={14} /> : label)}
    </button>
  );
}
